import service from "@irati/utils/tracking/index"

const tracking = {}

tracking.viewSearchByLocation = () => {
  service.trackPerksEvent("geo_start_search")
}

tracking.searchByLocationClickAction = (location, query) => {
  const data = {
    result_location: location,
    search_query: query
  }
  service.trackPerksEvent("geo_click_search_result_body", data)
}

tracking.searchByLocationClickViewPerk = (location, query) => {
  const data = {
    result_location: location,
    search_query: query
  }
  service.trackPerksEvent("geo_click_search_result_link", data)
}

tracking.clickPerksHomepagePerksNearMeCTA = (city) => {
  const data = {city}
  service.trackPerksEvent("geo_click_perks_homepage_perks_near_me_cta", data)
}

tracking.viewPerksHomepagePerksNearMeLane = (city) => {
  const data = {city}
  service.trackPerksEvent("geo_view_perks_homepage_perks_near_me_lane", data)
}

export default tracking
